/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Linking } from 'react-native'

import { TREATMENT_OPTIONS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentOptions'
import { TREATMENT_RECOMMENDATION_TIER } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/treatmentRecommendationsConstants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { Link } from '../atoms/link/Link'

export const psjh: GetCustomerCopyFunc = () => {
  const providenceHealthIndividualTherapyConfiguration = {
    analyticsName: 'Trusana Behavioral Health Concierge',
    title: (
      <FormattedMessage
        defaultMessage='Trusana Behavioral Health Concierge'
        description='Title for "Trusana Behavioral Health Concierge" when shown as a secondary treatment recommendation'
      />
    ),
    description: (
      <FormattedMessage
        defaultMessage='Providence caregivers, their dependents, and/or household members in AK, CA, ID, MT, NM, OR, WA, and TX have free, same-day, or next-day access to virtual counseling and care navigation through the Trusana platform.{lineBreak}{lineBreak}Learn more about our services or <link>schedule an appointment</link> through the Trusana platform. Appointments are available from 7a-8p (Pacific Time), 7 days/week.'
        description='Description for "Trusana behavioral health concierge"'
        values={{
          lineBreak: '\n',
          link: (chunks: string) => (
            <Link text={chunks} onPress={() => Linking.openURL('https://www.trusana.com/user-flow-type/EAP')} />
          ),
        }}
      />
    ),
    buttonText: (
      <FormattedMessage
        defaultMessage='Find a Behavioral Health Concierge Provider'
        description='Button text to find a Trusana behavioral health concierge provider'
      />
    ),
    url: 'https://www.trusana.com/user-flow-type/EAP',
  }

  return {
    treatmentOptions: [
      {
        option: TREATMENT_OPTIONS.ONSITE_THERAPY,
        config: { customCopy: providenceHealthIndividualTherapyConfiguration },
        optionRanking: { [TREATMENT_RECOMMENDATION_TIER.TIER_2]: 2, [TREATMENT_RECOMMENDATION_TIER.TIER_3]: 1 },
      },
    ],
  }
}
